import { CademyError } from '@shared/domain-shared';
import { Field, Form as FormType } from '@shared/types';
import { FunctionComponent, useId, useMemo } from 'react';
import { FormError, FormErrorProps } from '../FormError';
import { CustomFormField } from '../../../CustomForm/CustomForm';

export type FormProps = {
    fields: Array<Field>;
    validations?: FormType['validations'];
    disabled?: boolean;
    error?: CademyError | null;
    disabledFields?: Array<Field['_id']>;
};

export const Form: FunctionComponent<FormProps> = ({
    fields,
    validations,
    disabled,
    error,
    disabledFields = [],
}) => {
    const id = useId();

    const fieldMap: FormErrorProps['fieldMap'] = useMemo(() => {
        return fields.reduce(
            (fieldMap: FormErrorProps['fieldMap'], field): FormErrorProps['fieldMap'] => {
                return {
                    ...fieldMap,
                    [field._id]: {
                        label: field.label || '',
                        id: `${id}_${field._id}`,
                    },
                };
            },
            {}
        );
    }, [fields, id]);

    return (
        <div>
            <FormError error={error || null} fieldMap={fieldMap} />
            {fields.map((field) => {
                return (
                    <CustomFormField
                        key={field._id}
                        fieldId={`${id}_${field._id}`}
                        disabled={disabled || disabledFields.includes(field._id)}
                        required={
                            field._id === 'system_first_name' ||
                            field._id === 'system_last_name' ||
                            field._id === 'system_email' ||
                            validations?.some(
                                (validation) =>
                                    validation.field_ref === field._id &&
                                    validation.condition === 'required' &&
                                    validation.value === true
                            )
                        }
                        {...field}
                    />
                );
            })}
        </div>
    );
};
